import { createStyles, WithStyles, withStyles } from '@material-ui/core';
import CardContent from '@material-ui/core/CardContent';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography';
import withCountry, { IWithCountryProps } from 'enhancers/withCountry';
import withGlobalRegistrationPageQuery, {
  IRegistrationItem,
  WithGlobalRegistrationPageQueryProps,
} from 'enhancers/withGlobalRegistrationPageData';
import withLanguageState, { WithLanguageProps } from 'enhancers/withLanguageState';
import * as React from 'react';
import styled from 'styled-components';

interface IProps {
  name: string;
  items: IRegistrationItem[];
  className?: string;
}

const styles = createStyles({
  closed: {
    background: '#f93549',
    color: 'white'
  },
  comingSoon: {
    background: '#3d1152',
    color: 'white'
  },
  open: {
    background: '#00ce7c'
  }
});

type Props = IProps &
  WithLanguageProps &
  WithGlobalRegistrationPageQueryProps &
  IWithCountryProps &
  WithStyles<typeof styles>;

export const RegistrationItem: React.SFC<Props> = props => {
  const getStatus = (status: string) => {
    if (!props.loading && props.data && props.data.fetch.Common.Page) {
      switch (status) {
        case 'Open': {
          return props.data.fetch.Common.Page.Open;
        }
        case 'Closed': {
          return props.data.fetch.Common.Page.Closed;
        }
        default: {
          return props.data.fetch.Common.Page.ComingSoon;
        }
      }
    }
    return status;
  };
  const getStyle = (status: string) => {
    switch (status) {
      case 'Open': {
        return props.classes.open;
      }
      case 'Closed': {
        return props.classes.closed;
      }
      default: {
        return props.classes.comingSoon;
      }
    }
  };
  const el = (name: string) => (
    <Typography variant="h4" style={{ fontSize: 18 }}>
      {props.getText(name)}
    </Typography>
  );
  return (
    <React.Fragment>
      <Title className={props.className}>{props.getText(props.name)}</Title>
      <Container>
        {props.items.map((item, i) => {
          return (
            <ItemContainer key={i}>
              <Item className={props.className}>
                <Content>
                  {item.Link && item.Status === 'Open' ? (
                    <a
                      target="_blank"
                      style={{ color: 'blue' }}
                      href={item.Link}
                    >
                      {el(item.Name)}
                    </a>
                  ) : (
                    el(item.Name)
                  )}
                  <ChipContainer>
                    <Chip
                      classes={{ root: getStyle(item.Status) }}
                      label={getStatus(item.Status)}
                    />
                  </ChipContainer>
                </Content>
              </Item>
            </ItemContainer>
          );
        })}
      </Container>
    </React.Fragment>
  );
};

const ChipContainer = styled.div`
  padding-left: 16px;
`;

const Content = styled(CardContent)`
  display: flex;
  align-items: center;
`;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Item = styled.div``;

const Title = styled.h2`
  text-decoration: underline;
`;

const ItemContainer = styled.div`
  padding: 16px;
`;

export default withStyles(styles)(
  withCountry(
    withGlobalRegistrationPageQuery(withLanguageState(RegistrationItem))
  )
);



// WEBPACK FOOTER //
// ./src/components/RegistrationTable/RegistrationItem.tsx